import React from "react";

export const VideoInterviewTypeBadge = () => (
        <svg
            width="47"
            height="20"
            viewBox="0 0 47 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="47" height="20" rx="3" fill="#E9E9F0" />
            <path
                d="M12.172 5.9845L9.87201 12.0105L7.56051 5.9845H6.20351L9.40051 14H10.3435L13.529 5.9845H12.172ZM14.8057 14H16.0362V5.9845H14.8057V14ZM18.2534 14H20.5074C23.2099 14 24.6704 12.6085 24.6704 10.0555C24.6704 7.4565 23.1639 5.9845 20.5189 5.9845H18.2534V14ZM19.4839 12.8615V7.123H20.5074C22.4969 7.123 23.4284 8.043 23.4284 10.0095C23.4284 11.9875 22.4969 12.8615 20.3924 12.8615H19.4839ZM26.3281 14H31.6296V12.8615H27.5586V10.458H31.2961V9.3195H27.5586V7.123H31.6296V5.9845H26.3281V14ZM36.6458 14.1495C38.8883 14.1495 40.4178 12.4935 40.4178 9.998C40.4178 7.491 38.8998 5.835 36.6458 5.835C34.3918 5.835 32.8623 7.491 32.8623 9.998C32.8623 12.4935 34.3918 14.1495 36.6458 14.1495ZM36.6458 12.9765C35.0933 12.9765 34.0928 11.838 34.0928 9.998C34.0928 8.1465 35.0933 7.008 36.6458 7.008C38.1983 7.008 39.1873 8.158 39.1873 9.998C39.1873 11.8265 38.1983 12.9765 36.6458 12.9765Z"
                fill="black"
                fill-opacity="0.54"
            />
        </svg>
    );
